export default __webpack_public_path__ + "static/IlonaKravchenko-fcf82c27228ecb769de2f431a6940b71.jpg";